//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import styled from 'styled-components';
//  -- Components ---------------------
import { Col, Input, Row, Select, Space, Table, Modal, Spin, Tooltip, Form } from 'antd';
import { SearchOutlined, InfoCircleOutlined, BankOutlined, UserOutlined, TeamOutlined, CalendarOutlined, BookOutlined, AppstoreOutlined, FileTextOutlined, SortAscendingOutlined } from '@ant-design/icons';
import SentryWrap from 'components/Sentry';
//  -- Constants ----------------------

//  -- Features -----------------------

//  -- Thunks -------------------------
import { DistrictBg } from 'utils/assets/images';
import {
  handleContentExamBooks,
  handleGetFilterData,
  handleListChapterUnitData,
  handleListContentBookData,
  handleListContentExamData,
  handleListContentPassingExamData,
  handleListContentPassingExamStudentData,
  handleListGetSchool
} from 'store/organizations/thunks';
import moment from 'moment';
import color from 'utils/constants/color';
import { formatExportStudentId } from 'utils/formatExportStudentId';
import { handleListDistTeacher } from 'store/users/thunks';
import { isEmpty, filter, map, find, groupBy } from 'lodash';
import { Alert, Modal as MMOdal, Snackbar } from '@mui/material';
import { ViewList } from '@mui/icons-material';
import Loading from 'components/Loading';
import { DownloadOutlined } from '@ant-design/icons';
import { utils, writeFile } from 'xlsx';
import COLOR from 'utils/constants/color';
import * as Sentry from '@sentry/react';
const { Option } = Select;
const { Search } = Input;
const years = new Date().getFullYear();
const upcomming_year = `${years}-${years + 1}`;
const downcomming_year = `${years - 1}-${years}`;
const YEAR_SELECTER = [upcomming_year, downcomming_year];
import {
  Table as Muitable,
  TableBody,
  TableCell,
  TableContainer as MuiTableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Skeleton,
  TablePagination,
} from "@mui/material"
import AssignmentImgModal from 'features/AssignmentImgModal';
import { handleListActiveBooksByClass, handleListAllowedBooks } from 'store/books/thunks';
import { useAllBook, useDistrictActiveBooks } from 'store/books/selectors';
import { handleListCourseInfo } from 'store/standardexams';
import { useGetMaskId } from 'components/hooks/maskId/useGetMaskId';
import { Dropdown } from 'antd';
import { saveAs } from "file-saver";
import { CaretDownOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const VideoContainer = styled.div`
  height: auto;
  flex: 1;
  justify-content: center;
`;

const ContentLoading = ({ isLoading, isClose }) => {
  return (
    <MMOdal
      // className={classes.modal}
      open={isLoading}
    >
      <VideoContainer>
        <Spin size="large" style={{ position: 'absolute', top: '50%', left: '50%' }} />
      </VideoContainer>
    </MMOdal>
  );
};

const Wrapper = styled.div`
  height: 100%;
  width: calc(100% + 50px);
  margin-left: -25px;
  background-image: url(${DistrictBg});
  background-position: 100% 100%;
  background-size: cover;
`;

const TableContainer = styled.div`
  margin-bottom: 20px;
`;
const CustomTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: rgb(239, 246, 254);
  }
`;
const CustomTableStudentSub = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: ${color.indigo200};
    color: #fff;
  }
  &.ant-table-wrapper {
    .ant-table-thead > tr > th {
      background-color: ${color.indigo200};
      color: #fff;
    }

    .ant-table-tbody > tr > td {
      background-color: rgb(58, 58, 58);
      color: #fff;
    }

    .ant-table-tbody > tr:hover > td {
      background-color: rgb(58, 58, 58);
      color: #fff;
    }

    .ant-table-column-sort {
      background: rgb(58, 58, 58);
      color: #fff;
    }
  }
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 5px !important;
    border: 1px solid #d9d9d9 !important;
    background-color: rgb(237 237 237) !important;
    height: 40px !important;
    text-align: center;
    justify-content: center;
    align-items: center;
    cursor: pointer !important;
  }
  .ant-select-dropdown {
  }
`;
const Title = styled.div`
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
`;

const StyledSearchInput = styled(Input)`
  height: 50px;
  margin-bottom: 14px;
  .ant-input-prefix {
    margin-right: 8px;
    color: rgba(0, 0, 0, 0.25);
  }

  .ant-input {
    border-radius: 4px;
  }

  /* Add more styles if you need */
`;

const StyledTable = styled(Table)`
  && tbody > tr > td {
    text-align: center;
  }
`;
const NoOfQuestions = styled.span`
  position: absolute;
  right: 10px;
  top: 14px;
  z-index: 99;
  @media screen and (max-width:400px){
    font-size: 12px;
    top: 16px;
  }
`;
const IconButton = styled.button`
  border: none;
  cursor: pointer;
  height: 20px;
  margin-left: 5px;
  background-color: transparent;
`;

const StyledModalHeader = styled.div`
  background-color: #f0f0f0;
  padding: 16px;
  color: #333;
  font-weight: 500;
  text-align: center; // Center the title text if desired
`;
const DownloadButton = styled.button`
  border-radius: 5px !important;
  border: none;
  cursor: pointer;
  outline: none;
  transition: all 300ms ease;
  margin-right: 16px;
  height: 40px;
  background: ${COLOR.green200};
  color: #fff;
  margin-top: 20px;
  padding-left: 12px;
  padding-right: 12px;
  &:hover {
    background: ${COLOR.green1000};
  }
`;

// Styled modal body
const StyledModalBody = styled.div`
  padding: 16px 0px;  
`;

const Image = styled.img`
    width: 60px;
    height: 67px;
    
`;

const SearchBar = ({ onSearch }) => {
  return (
    <StyledSearchInput
      prefix={<SearchOutlined />}
      placeholder="Search by student name"
      onChange={(e) => onSearch(e.target.value)}
    />
  );
};

const SortingMenu = ({ classData, onFilter, selected_class }) => {
  const [selectedClass, setSelectedClass] = useState(null);
  useEffect(() => {
    setSelectedClass(selected_class);
  }, [selected_class]);

  const onSelectCh = (txt) => {
    setSelectedClass(txt);
    onFilter(txt);
  };
  return (
    <div>
      <ModernSelect
        className="apExamSelect"
        showSearch
        bordered={false}
        placeholder={'Select classes'}
        style={{ width: '100%' }}
        value={selectedClass}
        onChange={onSelectCh}
        options={classData}
        filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
      />
    </div>
  );
};

const InfoTooltip = ({ message }) => (
  <Tooltip title={message || ''}>
    <InfoCircleOutlined style={{ marginLeft: 8, color: color.redishpink }} />
  </Tooltip>
);

const SELECT_WIDTH = 200;
const fail_pass = {
  fail: '🔴',
  pass: '🟢',
};

const FilterContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  padding-top: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  
  @media (max-width: 768px) {
    padding: 16px;
    margin-bottom: 16px;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
    margin-bottom: 12px;
  }
`;

const FilterTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  align-items: end;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  @media (max-width: 480px) {
    gap: 12px;
  }
`;

const FilterItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const FilterLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
`;

const ModernSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 8px !important;
    border: 1px solid #e5e7eb !important;
    background-color: #ffffff !important;
    height: 44px !important;
    padding: 8px 12px !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
    transition: all 0.2s ease !important;
    
    &:hover {
      border-color: #d1d5db !important;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
    }
    
    &:focus {
      border-color: #3b82f6 !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
    }
  }
  
  .ant-select-arrow {
    color: #6b7280 !important;
  }
  
  .ant-select-selection-item {
    color: #1f2937 !important;
    font-weight: 500 !important;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: -10px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

const ModernButton = styled.button`
  border-radius: 8px !important;
  border: none !important;
  cursor: pointer !important;
  outline: none !important;
  transition: all 0.2s ease !important;
  height: 44px !important;
  padding: 0 20px !important;
  font-weight: 500 !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  
  &.primary {
    background: #3b82f6 !important;
    color: #ffffff !important;
    
    &:hover {
      background: #2563eb !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
    }
  }
  
  &.secondary {
    background: #f3f4f6 !important;
    color: #374151 !important;
    
    &:hover {
      background: #e5e7eb !important;
      transform: translateY(-1px) !important;
    }
  }
`;

const DownButton = styled.button`
    display: flex;
    align-items: center;
    border: none;
    cursor: pointer;
    outline: none;
    transition: all 300ms ease;
    margin-right: 16px;
    height: 40px;
    background: ${COLOR.green200};
    color: #fff;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 8px;
    &:hover {
      background: ${COLOR.green1000};
    }
`;

const DistrictContainer = ({
  users,
  schools,
  currentOrg,
  distTeacher,
}) => {
  const [errorMessage, setErrorMessage] = useState('');
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [activeSession, setActiveSession] = useState(
    moment().get('month') < 7 ? downcomming_year : upcomming_year,
  );
  const [alertSakeBar, setAlertSakeBar] = useState({ open: false, message: '', severity: "success" })
  const [studentExamData, setStudentExamData] = useState([]);
  const [filteredstudentExamData, setFilteredStudentExamData] = useState([]);
  const [studentUnitExamData, setStudentUnitExamData] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [number_of_questions, setNumberOfQuestions] = useState(0);
  const [selected_teacher, setSelectedTeacher] = useState(null);
  const [selected_school, setSelectedSchool] = useState(null);
  const [selected_class, setSelectedClass] = useState(null);

  const [selected_units, setSelectedUnits] = useState('');

  const [selected_exam, setSelectedExam] = useState('');
  const [selected_exam_type, setSelectedExamType] = useState('');
  const [selected_exam_data, setSelectedExamData] = useState({});

  const [imageModalOpen, setImageModalOpen] = useState(false);

  const [selected_books, setSelectedBooks] = useState(null);
  const [showStudentSubmission, setShowStudentSubmission] = useState(false);
  const [studentSubmissionDataLoading, setStudentSubmissionDataLoading] = useState(false);
  const [selectedstudentUnitExamData, setselectedStudentUnitExamData] = useState([]);
  const [selected_sort_by, setSelectedSortBy] = useState('highest');
  // compare state
  const [isCompareMode, setIsCompareMode] = useState(false);
  const [compareLoading, setCompareLoading] = useState(false);
  const [compareData, setCompareData] = useState([]);
  const [printloader, setPrintloader] = useState(false);
  const [isAssessmentBook, setIsAssessmentBook] = useState([]);
  const [district_books, setDistrictBooks] = useState([]);
  const [book_units, setBookUnits] = useState([]);
  const [book_exams, setBookExams] = useState([]);
  const [allBookExams, setAllBookExams] = useState([]);
  const [selectedTeacherClasses, setSelectedTeacherClasses] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [selected_course, setSelectedCourse] = useState(null);
  const [selectedCourseForAll, setSelectedCourseForAll] = useState(null);
  const [allCourseClasses, setAllCourseClasses] = useState([]);
  const [courseInfo, setCourseInfo] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {generateMaskId} = useGetMaskId("ebook");
  const [activeBooks, setActiveBooks] = useState([]);

  useEffect(() => {
    if (selected_school === 'All') {
      setActiveBooks({ book_id: [] });
      return;
    }
    const fetchActiveBooks = async () => {
      const result = await dispatch(
        handleListActiveBooksByClass({
          classId: selected_class,
        }),
      );
      setActiveBooks(result);
    };
    fetchActiveBooks();
  }, [selected_class, selected_school, dispatch]);

  const getBookData = async (bookOptions) => {
    const chapterUnitData = await dispatch(handleListChapterUnitData());
    const findChapter = chapterUnitData?.data?.find((obj) => obj?.chapter === bookOptions);
    setBookUnits(findChapter?.units || []);

    if (findChapter?.units?.length > 0) {
      // Collect all exams and unit_exams from all units
      const allExams = [];
      findChapter.units.forEach((unit) => {
        if (unit.exams && unit.exams.length > 0) {
          allExams.push(...unit.exams.map((e) => ({ ...e, unitTitle: unit.title, type: 'exam' })));
        }
        if (unit.unit_exams && unit.unit_exams.length > 0) {
          allExams.push(
            ...unit.unit_exams.map((e) => ({ ...e, unitTitle: unit.title, type: 'unit_exam' })),
          );
        }
      });

      // Store all exams for filtering
      setAllBookExams(allExams);
      setSelectedUnits(findChapter.units[0].title || '');

      // Optionally set default selected exam if you want
      if (allExams.length > 0) {
        const findUnitsExam = allExams?.filter((x) => x?.unitTitle === findChapter.units[0].title);
        if (findUnitsExam.length > 0) {
          setBookExams(findUnitsExam);
          setSelectedExam(findUnitsExam[0].exam_id || findUnitsExam[0].id);
          setSelectedExamType(findUnitsExam[0].exam_type);
          setSelectedExamData(findUnitsExam[0]);
        } else {
          setBookExams([]);
          setSelectedExam('');
          setSelectedExamType('');
          setSelectedExamData({});
        }
      } else {
        setBookExams([]);
        setSelectedExam('');
        setSelectedExamType('');
        setSelectedExamData({});
        setFilteredStudentExamData([]);
      }
    } else {
      setAlertSakeBar({
        open: true,
        message: "No exams found in this book. Please choose another.",
        severity: "info"
      })
      setSelectedUnits('');
      setAllBookExams([]);
      setBookExams([]);
      setSelectedExam('');
      setSelectedExamType('');
      setSelectedExamData({});
      setFilteredStudentExamData([]);
    }
  };

  const filterExamsByUnit = (selectedUnit) => {
    try {
      if (!selectedUnit) {
        setBookExams([]);
        setSelectedExam('');
        setSelectedExamType('');
        setSelectedExamData({});
      } else {
        const filteredExams = allBookExams.filter((exam) => exam.unitTitle === selectedUnit);
        setBookExams(filteredExams);
        if (filteredExams.length > 0) {
          setSelectedExam(filteredExams[0].exam_id || filteredExams[0].id);
          setSelectedExamType(filteredExams[0].exam_type);
          setSelectedExamData(filteredExams[0]);
        } else {
          setSelectedExam('');
          setSelectedExamType('');
          setSelectedExamData({});
        }
      }
    } catch (error) {
      console.error('Error filtering exams by unit:', error);
      setBookExams([]);
      setSelectedExam('');
      setSelectedExamType('');
      setSelectedExamData({});
    }
  };

  const useAllBooks = useAllBook();
  const districtActiveBooks = useDistrictActiveBooks();

  const getBookIds = useMemo(() => {
    if(activeBooks?.book_id?.length > 0) {
      return activeBooks?.book_id;
    }
    return [];
  }, [activeBooks])

  const booksData = useMemo(() => {
    if (selected_school === 'All') {
      return Array.isArray(districtActiveBooks) ? districtActiveBooks : [];
    }
    const list = Array.isArray(useAllBooks) ? useAllBooks : [];
    const classBookIdSet = new Set(getBookIds.map(String));
    return list.filter((book) => classBookIdSet.has(String(book.id)));
  }, [selected_school, districtActiveBooks, useAllBooks, getBookIds]);

  async function fetchBook() {
    try {
      if (Array.isArray(booksData) && booksData.length > 0) {
        const bookOptions = booksData.map((v, i) => {
          return {
            title: `${v?.description}`,
            value: v?.id,
          };
        });

        // Set the first book as default
        if (bookOptions.length > 0) {
          setSelectedBooks(bookOptions[0].value);
          getBookData(bookOptions[0].value);
        }
        setDistrictBooks(bookOptions);
      } else {
        setDistrictBooks([]);
        setSelectedBooks(null);
      }
    } catch (e) {
      console.error('Error fetching books:', e);
      setSelectedBooks('all');
    }
  }
  useEffect(() => {
    fetchBook();
  }, [booksData]);

  useEffect(() => {
    if (Array.isArray(users)) {
      setTeachers(filter(distTeacher, ['role', 'teacher']));
    }
  }, [distTeacher]);

  useEffect(() => {
    async function fetchData() {
      try {
        await getCurrentUser();
      } catch (error) {
        Sentry.captureException(`470 Error in fetchData: ${error}`);
      }
    }
    fetchData();
  }, []);
  const fetchDistrictData = async () => {
    try {
      if (!isEmpty(currentOrg)) {
        dispatch(handleListGetSchool(currentOrg.id));
        dispatch(handleListDistTeacher(currentOrg.id));
        const bookData = await dispatch(handleListContentBookData());
        setIsAssessmentBook(bookData);
      }
    } catch (error) {
      Sentry.captureException(`471 Error in fetchDistrictData: ${error}`);
    }
  };
  useEffect(() => {
    fetchDistrictData();
  }, [currentOrg]);

  useEffect(() => {
    const fetchCourseInfo = async () => {
      if (currentOrg?.id) {
        try {
          const result = await dispatch(handleListCourseInfo({ organisationId: currentOrg.id }));
          if (result?.data) {
            setCourseInfo(result.data);
          }
        } catch (error) {
          Sentry.captureException(`Error fetching course info: ${error}`);
        }
      }
    };
    fetchCourseInfo();
  }, [currentOrg, dispatch]);

  const examIdsPayload = useMemo(() => {
    if (selected_exam === 'all' && Array.isArray(book_exams) && book_exams.length > 0) {
      return book_exams.map((e) => e.exam_id || e.id);
    }
    return null;
  }, [selected_exam, book_exams]);

  async function fetchData() {
    if (selected_school === 'All') {
      if (!selectedCourseForAll || !currentOrg) return;
    } else {
      if (!currentOrg || !selected_school || !selected_teacher || !selected_class) return;
    }
    setLoading(true);
    setErrorMessage('');
    const dt = {
      session: activeSession,
      id: currentOrg.id,
      school_id: selected_school === 'All' ? null : selected_school,
      units: selected_units || null,
      exams: selected_exam === 'all' ? null : selected_exam,
      book_id: selected_books === 'all' ? null : selected_books,
      teacher_id: selected_school === 'All' ? null : selected_teacher,
      orgId: currentOrg.id,
      class_id: selected_school === 'All' ? null : selected_class,
      exam_id: selected_exam === 'all' ? null : selected_exam,
      exam_ids: examIdsPayload,
      exam_type: selected_exam_type,
      course_id: selected_school === 'All' ? selectedCourseForAll : null,
    };
    try {
      if (dt.units && (dt.exams || dt.exam_ids?.length)) {
        const exam_data = await dispatch(handleListContentPassingExamData(dt));
        if (exam_data && exam_data.statusCode == 200) {
          setStudentUnitExamData(exam_data.data || []);
        }
      }
      const data = await dispatch(handleListContentExamData(dt));
      if (data && data.statusCode == 200) {
        setStudentExamData(data.data);
        setFilteredStudentExamData(data.data);
        setStudentUnitExamData(prev => prev);
        setNumberOfQuestions(data.number_of_questions || 0);
      } else if (data?.statusCode == 400) {
        setStudentExamData([]);
        setFilteredStudentExamData([]);
        setNumberOfQuestions(0);
        setErrorMessage(data.message);
      }
    } catch (error) {
      Sentry.captureException(`472 Error in fetchData: ${error}`);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, [
    currentOrg,
    selected_school,
    selected_units,
    selected_exam,
    selected_books,
    selected_teacher,
    activeSession,
    selected_class,
    selectedCourseForAll,
    examIdsPayload,
  ]);

  useEffect(() => {
    setIsCompareMode(false);
    setCompareData([]);
  }, [
    selected_school,
    selected_teacher,
    selected_class,
    selected_units,
    selected_exam,
    selected_books,
    activeSession,
    selectedCourseForAll,
  ]);
  useEffect(() => {
    setIsCompareMode(false);
    setCompareData([]);
  }, [studentUnitExamData]);

  const fetchUserData = async (user_id) => {
    setShowStudentSubmission(true);
    setStudentSubmissionDataLoading(true);
    setselectedStudentUnitExamData([]);
    const dt = {
      session: activeSession,
      id: currentOrg.id,
      school_id: selected_school === 'All' ? null : selected_school,
      units: selected_units || null,
      exams: selected_exam === 'all' ? null : selected_exam,
      book_id: selected_books === 'all' ? null : selected_books,
      teacher_id: selected_school === 'All' ? null : selected_teacher,
      user_id: user_id,
      orgId: currentOrg.id,
      exam_id: selected_exam === 'all' ? null : selected_exam,
      exam_ids: selected_exam === 'all' ? examIdsPayload : null,
      course_id: selected_school === 'All' ? selectedCourseForAll : null,
      exam_type: selected_exam_type,
      class_id: selected_class,
    };
    try {
      const exam_data = await dispatch(handleListContentPassingExamStudentData(dt));
      if (exam_data && exam_data.statusCode === 200) {
        setselectedStudentUnitExamData(exam_data.data || []);
      }
    } catch (error) {
      Sentry.captureException(`473 Error in fetchUserData: ${error}`);
    } finally {
      setStudentSubmissionDataLoading(false);
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'user',
      key: 'user',
      width: 140,
      render: (user, { number_of_submissions }) => (
        <div style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}>
          {user?.firstName || ''} {user?.lastName || ''}{' '}
          {number_of_submissions > 0 ? (
            <IconButton onClick={() => fetchUserData(user.id)}>
              {' '}
              <ViewList style={{ fontSize: 14 }} />
            </IconButton>
          ) : null}
        </div>
      ),
    },
    {
      title: 'Score',
      dataIndex: 'score',
      key: 'score',
      width: 140,
      render: (score, { is_completed, manual_graded, no_assessment_assigned }) => (
        <span style={{ marginRight: 8 }}>
          {score}{' '}
          {(!is_completed || manual_graded) && no_assessment_assigned > 0 ? (
            <InfoTooltip
              message={
                !is_completed
                  ? `Assignment submission incomplete.`
                  : `The grade has been manually entered by the teacher.`
              }
            />
          ) : null}
        </span>
      ),
    },
    {
      title: 'Questions Passed',
      dataIndex: 'correct',
      width: 140,
      key: 'correct',
      render: (c) => <span style={{ color: color.green }}>{c}</span>,
    },
    {
      title: 'Questions Failed',
      dataIndex: 'incorrect',
      width: 140,
      key: 'incorrect',
      render: (c) => <span style={{ color: color.red }}>{c}</span>,
    },
    {
      title: 'Questions Incomplete',
      dataIndex: 'not_attempted',
      key: 'not_attempted',
      width: 140,
      render: (c) => <span style={{ color: color.red }}>{c}</span>,
    },
    {
      title: 'Number of Assessments',
      dataIndex: 'no_assessment_assigned',
      width: 140,
      key: 'no_assessment_assigned',
    },
  ];
  const downloadColumns = [
    columns[0],
    {
      title: 'Student ID',
      key: 'studentId',
    },
    ...columns.slice(1),
  ];
  const ExamUnitcolumns = [
    {
      title: 'Questions',
      dataIndex: 'question_id',
      key: 'question_id',
      render: (value, { question }) => {
        return (
          <span>
            {value}
            <InfoTooltip message={question ? question : ''} />
          </span>
        );
      },
    },
    {
      title: 'Passing',
      dataIndex: 'correct_percent',
      key: 'correct_percent',
      render: (value) => <span style={{ color: color.green }}>{value || '0'}%</span>,
    },
    {
      title: 'Failing',
      dataIndex: 'incorrect_percent',
      key: 'incorrect_percent',
      render: (value) => <span style={{ color: color.red }}>{value || '0'}%</span>,
    },
  ];
  const ExamUnitCompareColumns = [
    {
      title: 'Questions',
      dataIndex: 'question_id',
      key: 'question_id',
      render: (value, { question }) => {
        return (
          <span>
            {value}
            <InfoTooltip message={question ? question : ''} />
          </span>
        );
      },
    },
    {
      title: 'Passing (Current)',
      dataIndex: 'current_correct',
      key: 'current_correct',
      render: (value) => <span style={{ color: color.green }}>{value || '0'}%</span>,
    },
    {
      title: 'Passing (Last Year)',
      dataIndex: 'prev_correct',
      key: 'prev_correct',
      render: (value) => <span style={{ color: color.green }}>{value || '0'}%</span>,
    },
    {
      title: 'Failing (Current)',
      dataIndex: 'current_incorrect',
      key: 'current_incorrect',
      render: (value) => <span style={{ color: color.red }}>{value || '0'}%</span>,
    },
    {
      title: 'Failing (Last Year)',
      dataIndex: 'prev_incorrect',
      key: 'prev_incorrect',
      render: (value) => <span style={{ color: color.red }}>{value || '0'}%</span>,
    },
  ];
  const StudentExamUnitcolumns = [
    {
      title: 'Question',
      dataIndex: 'question_id',
      key: 'question_id',
      width: 140,
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Pregunta',
      dataIndex: 'question',
      key: 'question',
      render: (value) => <span style={{}}>{value}</span>,
    },
    {
      title: 'Met/fail',
      dataIndex: 'is_correct',
      key: 'is_correct',
      width: 80,
      render: (value) => <span style={{}}>{value ? fail_pass.pass : fail_pass.fail} </span>,
    },
  ];
  const school_option = useMemo(() => {
    const values = [{ label: 'All', value: 'All' }];
    if (!isEmpty(schools)) {
      values.push(
        ...schools.filter((k) => !k.demo).map((v) => ({ label: v.displayName, value: v.id })),
      );
    }
    return values;
  }, [schools]);

  const fetchTeacherClasses = async (teacher_id) => {
    setSelectedTeacherClasses([]);
    setSelectedClass(null);
    setSelectedCourse(null);
    try {
      const result = await handleGetFilterData(null, teacher_id, 'classes');
      if (result && result.success) {
        const uniqueCourses = result.data?.reduce((acc, curr) => {
          if (!curr.course_info || !curr.course_info.id) {
            const noCourseEntry = acc.find(c => c.value === null);
            if (!noCourseEntry) {
              acc.push({label: 'No Course', value: null, classes:[{id:curr.id, displayName:curr.displayName, code:curr.code}]})
            } else {
              noCourseEntry.classes.push({id:curr.id, displayName:curr.displayName, code:curr.code})
            }
          } else {
            if (!acc.find(c => c.value === curr.course_info.id)) {
              acc.push({label:curr.course_info.title, value:curr.course_info.id, classes:[{id:curr.id, displayName:curr.displayName, code:curr.code}]})
            } else {
              acc.find(c => c.value === curr.course_info.id).classes.push({id:curr.id, displayName:curr.displayName, code:curr.code})
            }
          }
          return acc;
        }, []);
        setAllCourses(uniqueCourses || []);

        if (uniqueCourses && uniqueCourses.length > 0) {
          const firstCourse = uniqueCourses[0];
          setSelectedCourse(firstCourse.value);
          const firstClass = firstCourse.classes?.[0];
          if (firstClass) {
            setSelectedClass(firstClass.id);
          }
        } else if (result.data && result.data.length > 0) {
          const s_class = result.data[0];
          if (s_class) {
            setSelectedClass(s_class.id);
          }
        }

        const dt = (result.data || []).map((k) => ({
          label: `${k.displayName || ''}`,
          value: k.id,
        }));
        setSelectedTeacherClasses(dt || []);
      }
    } catch (error) {
    } finally {
    }
  };

  const fetchTeacher = async (orgId, activeTeacher) => {
    setSelectedTeacherClasses([]);
    setSelectedClass(null);
    setSelectedTeacher(null);
    setSelectedCourse(null);
    try {
      const result = await handleGetFilterData(orgId, null, 'teacher');
      if (result && result.success) {
        const s_teacher = result.data?.[0];
        if (activeTeacher) {
          const activeTeacherData = result.data.find(k => k.id === activeTeacher);
          if (activeTeacherData) {
            setSelectedTeacher(activeTeacherData.id);
            await fetchTeacherClasses(activeTeacherData.id);
          }
        } else {
          if (s_teacher) {
            setSelectedTeacher(s_teacher.id);
            await fetchTeacherClasses(s_teacher.id);
          }
        }
        const dt = (result.data || []).map((k) => ({
          label: `${k.firstName || ''} ${k.lastName || ''}`,
          value: k.id,
        }));
      }
    } catch (error) {
      console.log(error.message, 'error in fetching school teacher');
    } finally {
    }
  };

  const filteredClassesByCourse = useMemo(() => {
    if (selected_school === 'All') {
      return [];
    }
    if (!selected_course || !allCourses || allCourses.length === 0) {
      return selectedTeacherClasses;
    }
    const selectedCourseData = allCourses.find(c => c.value === selected_course);
    if (!selectedCourseData || !selectedCourseData.classes) {
      return selectedTeacherClasses;
    }
    return selectedCourseData.classes.map(cls => ({
      label: cls.displayName || '',
      value: cls.id
    }));
  }, [selected_course, allCourses, selectedTeacherClasses, selected_school]);

  const onSchoolSelect = async (v) => {
    if (v === 'All') {
      setSelectedSchool('All');
      setSelectedTeacher(null);
      setSelectedCourse(null);
      setSelectedClass(null);
      setSelectedCourseForAll(null);
      setAllCourseClasses([]);
      setSelectedTeacherClasses([]);
      setAllCourses([]);
    } else {
      setSelectedSchool(v);
      setSelectedTeacher(null);
      setSelectedCourseForAll(null);
      setAllCourseClasses([]);
      await fetchTeacher(v);
    }
  };

  const onCourseSelectForAll = async (courseId) => {
    setSelectedCourseForAll(courseId);
    setSelectedClass(null);
    if (!courseId) {
      setAllCourseClasses([]);
      setStudentExamData([]);
      setFilteredStudentExamData([]);
      setStudentUnitExamData([]);
      return;
    }
    try {
      const result = await dispatch(handleGetFilterData(currentOrg.id, null, 'classes'));
      if (result && result.success && result.data) {
        const filteredClasses = result.data.filter(c => {
          if (courseId === null) {
            return !c.course_info || !c.course_info.id;
          }
          return c.course_info?.id === courseId;
        });
        const classIds = filteredClasses.map(c => c.id);
        setAllCourseClasses(classIds);
      }
    } catch (error) {
      Sentry.captureException(`Error fetching classes for course: ${error}`);
    }
  };

  useEffect(() => {
    const opt = school_option[1];
    if (opt && !selected_school) {
      setSelectedSchool(opt.value);
      fetchTeacher(opt.value);
    }
  }, [school_option]);

  // useEffect(() => {
  //     if (selected_school) {
  //         const teacher_list = filter(teachers, ['orgId', selected_school])
  //         const first_teacher = teacher_list[0];
  //         if (first_teacher && (!selected_teacher || !find(teacher_list, { 'id': selected_teacher }))) {
  //             setSelectedTeacher(first_teacher.id)
  //         }
  //     }
  // }, [selected_school, teachers, selected_teacher])

  const teacher_map = useMemo(() => {
    if (selected_school === 'All') {
      return [];
    }
    let tavl = [];
    const demo_school = schools.filter((k) => k.demo).map((k) => k.id);
    if (selected_school === 'all') {
      tavl = teachers
        .filter((e) => !demo_school.includes(e.orgId) && !e.demo)
        .map((v) => ({ label: `${v.lastName || ''}, ${v.firstName || ''}`, value: v.id }));
    } else {
      tavl = filter(teachers, ['orgId', selected_school]).map((v) => ({
        label: `${v.lastName || ''}, ${v.firstName || ''}`,
        value: v.id,
      }));
    }
    return tavl;
  }, [schools, teachers, selected_school]);

  const handleSearch = (txt) => {
    try {
      if (txt && txt.trim().length > 0) {
        const searchText = txt.toLowerCase();

        const filteredData = studentExamData.filter((k) => {
          const fullName = `${k.user.firstName}${k.user.lastName}`.toLowerCase();
          return fullName.includes(searchText);
        });

        setFilteredStudentExamData(filteredData);
      } else {
        setFilteredStudentExamData(studentExamData);
      }
    } catch (error) {
      Sentry.captureException(`474 Error in handleSearch: ${error}`);
      console.error('An error occurred while filtering data:', error);
    }
  };

  const handleClose = () => {
    setShowStudentSubmission(false);
  };
  function sortData(data, sortOrder = 'asc') {
    return data.sort((a, b) => {
      if (a.no_assessment_assigned === 0 && b.no_assessment_assigned !== 0) return 1;
      if (a.no_assessment_assigned !== 0 && b.no_assessment_assigned === 0) return -1;
      if (a.overall_score !== b.overall_score) {
        return sortOrder === 'asc'
          ? a.overall_score - b.overall_score
          : b.overall_score - a.overall_score;
      }
      return sortOrder === 'asc'
        ? a.no_assessment_assigned - b.no_assessment_assigned
        : b.no_assessment_assigned - a.no_assessment_assigned;
    });
  }

  const tableData = useMemo(() => {
    const dataToSort = [...filteredstudentExamData];
    return sortData(dataToSort, selected_sort_by === 'highest' ? 'desc' : 'asc');
  }, [filteredstudentExamData, selected_sort_by]);

  const tableDataByClass = useMemo(() => {
    if (!selected_exam) return [];
    if (selected_class) {
      return tableData.filter((student) => student.user.class_id === selected_class);
    } else {
      return tableData;
    }
  }, [tableData, selected_class, selected_exam]);

  const generateXLSX =async (format = 'xlsx') => {
    try {
      const uniqueRows = new Set();
      studentExamData.map((v) => {
        let userData = {};
        downloadColumns.forEach((acc) => {
          let k_name = acc.title;
          if (acc.key === 'user') {
            userData[k_name] = `${v.user.firstName || ''} ${v.user.lastName || ''}`;
          } else if (acc.key === 'studentId') {
            userData[k_name] = formatExportStudentId(v?.user?.studentId);
          } else {
            userData[k_name] = v[acc.key];
          }
        });
        uniqueRows.add(userData);
      });

      const rowdata = Array.from(uniqueRows);
      const finalData = { data: rowdata };
      const ExcelJS = (await import('exceljs')).default;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('content_exam');
      // 1. Add header row
      const headerRow = worksheet.addRow(downloadColumns.map((acc) => acc.title));
      // 🔹 Style header row
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF9DC3E6' } // dark grey
        };
        cell.font = {
          color: { argb: 'FF000000' },
          bold: true
        };
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'thin', color: { argb: 'FF000000' } },
          left: { style: 'thin', color: { argb: 'FF000000' } },
          right: { style: 'thin', color: { argb: 'FF000000' } }
        };
      });

      // 2. Add data rows
      finalData?.data?.forEach((userd, index) => {
        const row = worksheet.addRow(Object.values(userd));

        // Excel rows start from 1
        // header = row 1
        // data starts from row 2

        const excelRowNumber = row.number;

        const dataIdx = excelRowNumber - 2;
        const fillArgb = dataIdx % 2 === 0 ? 'FFFFFFFF' : 'FFF5F5F5';
        row.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: fillArgb }
          };
          cell.font = {
            color: { argb: 'FF000000' }
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
          };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
          };
        });
      });

      // 3. Auto column width (recommended)
      worksheet.columns.forEach((col) => {
        let maxLength = 10;
        col.eachCell({ includeEmpty: true }, (cell) => {
          const val = cell.value ? cell.value.toString() : '';
          maxLength = Math.max(maxLength, val.length);
        });
        col.width = maxLength + 2;
      });

       // 4. Generate file
      const buffer = await workbook.xlsx.writeBuffer();
      const fileExtension = format === 'xlsx' ? 'xlsx' : 'csv';
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      saveAs(blob, `content_exam ${dayjs().format('DD-MM-YY hh:mm:ss')}.${fileExtension}`);

    } catch (error) {
      Sentry.captureException(`475 Error in generateXLSX: ${error}`);
      console.error('Error in unit exam and quizzes download:', error);
    }
  };

  const generateCSV = () => {
    try {
      const uniqueRows = new Set();
      studentExamData.map((v) => {
        let userData = {};
        downloadColumns.forEach((acc) => {
          let k_name = acc.title;
          if (acc.key === 'user') {
            userData[k_name] = `${v.user.firstName || ''} ${v.user.lastName || ''}`;
          } else if (acc.key === 'studentId') {
            userData[k_name] = formatExportStudentId(v?.user?.studentId);
          } else {
            userData[k_name] = v[acc.key];
          }
        });
        uniqueRows.add(userData);
      });
      const rowdata = Array.from(uniqueRows);
      const finalData = { data: rowdata };
      const wb = utils.book_new();
      const exambook = [downloadColumns.map((acc) => acc.title)];
      finalData.data.forEach((userd) => {
        exambook.push(Object.values(userd));
      });
      const ws = utils.aoa_to_sheet(exambook);
      utils.book_append_sheet(wb, ws, `content_exam`);
      writeFile(wb, `content_exam ${moment().format('DD-MM-YY hh:mm:ss')}.csv`);
    } catch (error) {
      Sentry.captureException(`475 Error in generateCSV: ${error}`);
      console.error('Error in exam gradebook download:', error);
    }
  };

  const onDownload = (format = 'xlsx') => {
    if (format === 'xlsx') {
      generateXLSX(format);
    } else {
      generateCSV(format);
    }
  };
  const downloadMenuItems = {
    items: [
      {
        key: 'xlsx',
        label: (
          <div onClick={() => onDownload('xlsx')}>
            Download as XLSX
          </div>
        ),
      },
      {
        key: 'csv',
        label: (
          <div onClick={() => onDownload('csv')}>
            Download as CSV
          </div>
        ),
      },
    ]
  };

  const getPrevSession = (sessionStr) => {
    try {
      const parts = String(sessionStr).split('-');
      const start = parseInt(parts?.[0], 10);
      const end = parseInt(parts?.[1], 10);
      if (Number.isFinite(start) && Number.isFinite(end)) {
        return `${start - 1}-${end - 1}`;
      }
    } catch (e) {}
    return sessionStr;
  };

  const onCompare = async () => {
    if (selected_school === 'All') {
      if (!currentOrg || !selectedCourseForAll) return;
    } else {
      if (!currentOrg || !selected_school || !selected_teacher) return;
    }
    if (isCompareMode) {
      setIsCompareMode(false);
      setCompareData([]);
      return;
    }
    const prevSession = getPrevSession(activeSession);
    const dtPrev = {
      session: prevSession,
      id: currentOrg.id,
      school_id: selected_school === 'All' ? null : selected_school,
      units: selected_units === 'all' ? null : selected_units,
      exams: selected_exam === 'all' ? null : selected_exam,
      book_id: selected_books === 'all' ? null : selected_books,
      teacher_id: selected_school === 'All' ? null : selected_teacher,
      orgId: currentOrg.id,
      class_id: selected_school === 'All' ? null : selected_class,
      exam_id: selected_exam === 'all' ? null : selected_exam,
      exam_ids: selected_exam === 'all' ? examIdsPayload : null,
      exam_type: selected_exam_type,
      course_id: selected_school === 'All' ? selectedCourseForAll : null,
    };
    try {
      setCompareLoading(true);
      const prevRes = await dispatch(handleListContentPassingExamData(dtPrev));
      const prevData = prevRes && prevRes.statusCode === 200 ? prevRes.data || [] : [];
      // merge current studentUnitExamData with prevData by question_id
      const questionIds = new Set([
        ...studentUnitExamData.map((k) => k.question_id),
        ...prevData.map((k) => k.question_id),
      ]);
      const prevMap = prevData.reduce((acc, item) => {
        acc[item.question_id] = item;
        return acc;
      }, {});
      const currMap = studentUnitExamData.reduce((acc, item) => {
        acc[item.question_id] = item;
        return acc;
      }, {});
      const merged = Array.from(questionIds).map((qid) => {
        const curr = currMap[qid] || {};
        const prev = prevMap[qid] || {};
        return {
          question_id: qid,
          question: curr.question || prev.question || '',
          current_correct: curr.correct_percent || 0,
          prev_correct: prev.correct_percent || 0,
          current_incorrect: curr.incorrect_percent || 0,
          prev_incorrect: prev.incorrect_percent || 0,
        };
      });
      setCompareData(merged);
      setIsCompareMode(true);
    } catch (error) {
      Sentry.captureException(`476 Error in onCompare: ${error}`);
      setIsCompareMode(false);
    } finally {
      setCompareLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number.parseInt(event.target.value, 10))
    setPage(0)
  }

  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: '', severity: '' })
  }

  const paginatedData = selectedstudentUnitExamData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <SentryWrap>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertSakeBar.open}
        autoHideDuration={7000}
        onClose={closeAlert}>
        <Alert onClose={() => { setAlertSakeBar({ open: false, message: '' }) }} severity={alertSakeBar.severity}>
            <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>
      <Modal
        title={null}
        wrapClassName='overlayClass'
        open={showStudentSubmission}
        onCancel={handleClose}
        closable={true}
        className="content-exam-pop"
        footer={null}
      >
        <StyledModalBody>
          {/* <CustomTableStudentSub
            columns={StudentExamUnitcolumns}
            dataSource={selectedstudentUnitExamData}
            pagination={{ position: 'bottomRight', pageSize: 100 }}
            scroll={{ y: 'calc(70vh - 104px)' }}
            sticky
            bordered
            loading={studentSubmissionDataLoading}
          /> */}
          {/* <Paper sx={{ mt: 4, minHeight:'50vh' }}> */}
            <MuiTableContainer sx={{borderRadius:'10px 10px 0px 0px'}}>
              <Muitable aria-label="user data table">
                <TableHead>
                  <TableRow>
                    {
                      StudentExamUnitcolumns && StudentExamUnitcolumns.map( (row, index) => {
                        return <TableCell key={row.title} sx={{ color: "#fff", backgroundColor: `${color.indigo200}` }}>{row.title}</TableCell>
                      } )
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.map((row, index) => (
                    <TableRow
                      key={index}
                      // sx={{
                      //   "&:nth-of-type(odd)": { backgroundColor: "action.hover" },
                      //   "&:hover": { backgroundColor: "action.selected" },
                      // }}
                    >
                      <TableCell component="th" scope="row" sx={{backgroundColor: '#2E3440', color:'#fff'}}>
                        {row.question_id}
                      </TableCell>
                      <TableCell sx={{backgroundColor: '#2E3440', color:'#fff'}}>{row.question}</TableCell>
                      <TableCell sx={{backgroundColor: '#2E3440', color:'#fff'}}>{row.is_correct ? fail_pass.pass: fail_pass.fail}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Muitable>
            </MuiTableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={selectedstudentUnitExamData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                "& .MuiTablePagination-select": {
                  backgroundColor: `${color.indigo200}`, // White background
                  color: "#fff",           // Black text
                  borderRadius: "4px",
                  padding: "4px 8px",
                },
                "& .MuiTablePagination-selectIcon": {
                  color: "#fff", // Makes dropdown arrow visible
                },
              }}
              // sx={{backgroundColor: `${color.indigo200}`, color:'#fff', borderRadius: '0px 0px 20px 20px'}}
            />
          {/* </Paper> */}
          {studentSubmissionDataLoading && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <Spin size="large" />
            </div>
          )}
        </StyledModalBody>
      </Modal>
      <div style={{ position: 'relative' }}>
        <ContentLoading isLoading={loading} />
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          <FilterContainer>
            <FilterGrid>
              <FilterItem>
                <FilterLabel>
                  <BankOutlined style={{ color: '#6b7280' }} />
                  Schools
                </FilterLabel>
                <ModernSelect
                  defaultValue={selected_school}
                  style={{ width: '100%' }}
                  showSearch
                  bordered={false}
                  value={selected_school}
                  placeholder={'Select School'}
                  options={school_option}
                  onChange={onSchoolSelect}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </FilterItem>

              {selected_school === 'All' ? (
                <FilterItem>
                  <FilterLabel>
                    <BookOutlined style={{ color: '#6b7280' }} />
                    Courses
                  </FilterLabel>
                  <ModernSelect
                    value={selectedCourseForAll}
                    style={{ width: '100%' }}
                    showSearch
                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                    options={courseInfo.map(c => ({ label: c.title, value: c.id }))}
                    onChange={(v) => {
                      onCourseSelectForAll(v);
                    }}
                    placeholder={'Select Course'}
                  />
                </FilterItem>
              ) : (
                <>
                  <FilterItem>
                    <FilterLabel>
                      <UserOutlined style={{ color: '#6b7280' }} />
                      Teachers
                    </FilterLabel>
                    <ModernSelect
                      defaultValue={'all'}
                      value={selected_teacher}
                      style={{ width: '100%' }}
                      showSearch
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                      options={teacher_map}
                      onChange={(v) => {
                        setSelectedTeacher(v);
                        fetchTeacherClasses(v);
                      }}
                      placeholder={'Select Teacher'}
                    />
                  </FilterItem>

                  <FilterItem>
                    <FilterLabel>
                      <BookOutlined style={{ color: '#6b7280' }} />
                      Courses
                    </FilterLabel>
                    
                    <ModernSelect
                      value={selected_course}
                      style={{ width: '100%' }}
                      showSearch
                      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                      options={allCourses.map(c => ({ label: c.label, value: c.value }))}
                      onChange={(v) => {
                        setSelectedCourse(v);
                        if (v && allCourses) {
                          const selectedCourseData = allCourses.find(c => c.value === v);
                          if (selectedCourseData && selectedCourseData.classes && selectedCourseData.classes.length > 0) {
                            setSelectedClass(selectedCourseData.classes[0].id);
                          } else {
                            setSelectedClass(null);
                          }
                        } else {
                          setSelectedClass(null);
                        }
                      }}
                      placeholder={'Select Course'}
                    />
                  </FilterItem>

                  <FilterItem>
                    <FilterLabel>
                      <TeamOutlined style={{ color: '#6b7280' }} />
                      Class
                    </FilterLabel>
                    <SortingMenu
                      grades={studentExamData}
                      classData={filteredClassesByCourse}
                      selected_class={selected_class}
                      onFilter={(v) => {
                        setSelectedClass(v);
                      }}
                    />
                  </FilterItem>
                </>
              )}

              <FilterItem>
                <FilterLabel>
                  <CalendarOutlined style={{ color: '#6b7280' }} />
                  Session
                </FilterLabel>
                <ModernSelect
                  value={activeSession}
                  style={{ width: '100%' }}
                  onChange={setActiveSession}
                  placeholder={'Select Session'}
                >
                  {map(YEAR_SELECTER, (x) => (
                    <Option value={x} key={x}>
                      {x}
                    </Option>
                  ))}
                </ModernSelect>
              </FilterItem>

              <FilterItem>
                <FilterLabel>
                  <BookOutlined style={{ color: '#6b7280' }} />
                  Book
                </FilterLabel>
                <ModernSelect
                  value={selected_books}
                  onChange={(val) => {
                    setSelectedBooks(val);
                    getBookData(val);
                  }}
                  style={{ width: '100%' }}
                  placeholder={'Select Book'}
                >
                  {district_books.map((x) => (
                    <Option value={x.value} key={x.value}>
                      {x.title}
                    </Option>
                  ))}
                </ModernSelect>
              </FilterItem>

              <FilterItem>
                <FilterLabel>
                  <AppstoreOutlined style={{ color: '#6b7280' }} />
                  Unit
                </FilterLabel>
                <ModernSelect
                  value={selected_units}
                  onChange={(v) => {
                    setSelectedUnits(v);
                    filterExamsByUnit(v);
                  }}
                  style={{ width: '100%' }}
                  placeholder={'Select Unit'}
                >
                  {book_units.map((x) => (
                    <Option value={x.title} key={x.title}>
                      {x.title}
                    </Option>
                  ))}
                </ModernSelect>
              </FilterItem>

              <FilterItem>
                <FilterLabel>
                  <FileTextOutlined style={{ color: '#6b7280' }} />
                  Exam
                </FilterLabel>
                <ModernSelect
                  value={selected_exam === '' ? undefined : selected_exam}
                  onChange={(v) => {
                    setStudentUnitExamData([]);
                    setSelectedExam(v);
                    if (v === 'all') {
                      setSelectedExamData({});
                      setSelectedExamType('');
                    } else {
                      const selectedExamObj = book_exams.find(
                        (exam) => (exam.exam_id || exam.id) === v,
                      );
                      setSelectedExamData(selectedExamObj || {});
                      setSelectedExamType(selectedExamObj?.exam_type || selectedExamObj?.type || '');
                    }
                  }}
                  style={{ width: '100%' }}
                  placeholder={
                    book_exams.length > 0
                      ? 'Select Exam'
                      : allBookExams.length > 0
                        ? 'No exams in this unit'
                        : 'No exams in this book'
                  }
                  notFoundContent="No exams"
                  disabled={allBookExams.length === 0}
                >
                  {book_exams.length > 0 && <Option value="all">All</Option>}
                  {book_exams.map((exam, idx) => (
                    <Option key={exam.exam_id || exam.id || idx} value={exam.exam_id || exam.id}>
                      {`${exam.type === 'exam' ? 'Exam' : 'Unit Exam'} - ${exam.unitTitle} - Page ${generateMaskId(exam.page, selected_books) || ''}`}
                    </Option>
                  ))}
                </ModernSelect>
              </FilterItem>

              <FilterItem>
                <FilterLabel>
                  <SortAscendingOutlined style={{ color: '#6b7280' }} />
                  Sort By
                </FilterLabel>
                <Form.Item label="" name="select" style={{ marginBottom: 0 }}>
                  <ModernSelect
                    defaultValue="highest"
                    value={selected_sort_by}
                    style={{ width: '100%' }}
                    onChange={setSelectedSortBy}
                    placeholder={'Select Sort'}
                  >
                    <Option value="highest">Highest</Option>
                    <Option value="lowest">Lowest</Option>
                  </ModernSelect>
                </Form.Item>
              </FilterItem>

              <div className='w-full flex items-center justify-between'>
              <ActionButtons>
              {selected_exam_data?.cover && (
                <div onClick={() => {
                  setImageModalOpen(true);
                }}>
                  <Image src={selected_exam_data?.cover} className='cursor-pointer' style={{ borderRadius: '8px', border: '2px solid #e5e7eb' }} />
                </div>
              )}
                <Dropdown menu={downloadMenuItems} placement="bottomLeft" trigger={['click']}>
                  <DownButton 
                    className="apExamSelect" 
                    onClick={e => e.preventDefault()}
                  >
                    {printloader ? <Loading size={20} /> : <DownloadOutlined style={{ marginRight: '4px' }} />}
                    Download
                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                  </DownButton>
                </Dropdown>
            </ActionButtons>

              </div>
              
          
            </FilterGrid>

          </FilterContainer>
          {errorMessage && <div style={{color: 'red', width: '100%', textAlign: "center"}}>{errorMessage}</div>}
          <AssignmentImgModal className="max-w-581px" modalOpen={imageModalOpen} setModalOpen={setImageModalOpen} page_src={selected_exam_data?.cover} />
        </Space>
        <Row style={{display:'flex', flexDirection:'row', flexWrap:'wrap', marginTop:'20px'}}>
          <Col xl={15} lg={24} md={24} sm={24} xs={24}>
            <TableContainer>
              <div style={{width:'100%'}}>
                  <Row>
                    <Col xl={24} lg={24} sm={16} xs={24} style={{ position: 'relative' }}>
                      <SearchBar
                        onSearch={handleSearch}
                        placeholder="Search by name"
                        style={{ width: '100%' }}
                      />{' '}
                      <NoOfQuestions>Number of questions {number_of_questions} </NoOfQuestions>
                    </Col>
                  </Row>
                  <Row>
            <div style={{width: '100%', overflowX: 'auto'}}>
              <CustomTable
                columns={columns}
                dataSource={tableDataByClass}
                pagination={{ position: 'bottomRight' }}
              />
            </div>
                  
              </Row>
              </div>
              
            </TableContainer>
          </Col>
          <Col className="customizeTableRght" xl={9} lg={24} md={24} sm={24} xs={24}>
            {selected_units && (selected_exam || selected_exam === 'all') && (
              <>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0px' }}
                >
                  <Title>Overall Passing per Question</Title>
                  <ModernButton
                    className="secondary"
                    onClick={onCompare}
                    style={{ display:'flex', flexDirection:'row', alignItems:'center', gap:'10px' }}
                  >
                    {compareLoading ? <Loading size={20} /> : null}
                    {isCompareMode ? 'Close' : 'Compare'}
                  </ModernButton>
                </div>
                <div style={{width: '100%', overflowX: 'scroll'}}>
                <StyledTable
                  columns={isCompareMode ? ExamUnitCompareColumns : ExamUnitcolumns}
                  dataSource={isCompareMode ? compareData : studentUnitExamData}
                  pagination={false}
                  loading={compareLoading}
                />
                </div>
              </>
            )}
          </Col>
        </Row>
      </div>
    </SentryWrap>
  );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  currentOrg: state.currentOrg,
  users: state.users,
  booksAllList: state.booksAllList,
  schools: state.schools,
  distTeacher: state.distTeacher,
});

export default connect(mapStateToProps, null)(DistrictContainer);
